module.exports = __webpack_public_path__ + "img/product13p.676d1032.png";